import { Record } from 'immutable';
import { DateTime } from 'luxon';
import { Map } from 'immutable';

export default class SaleRecord extends Record({
    id: null,
    status: 'open',
    sale_start: null,
    sale_end: null,
    consignment_start: null,
    consignment_end: null,
    consignment_end_iso: null, // raw ISO preserved for countdown logic
    discount: {
      active: false,
      time: '14:00',
      amount: 20
    },
    consignment_closed: false // evaluated at constructor, not part of schema
  }) {

    constructor(data) {
      if (Map.isMap(data)) data = data.toJS()

      if (DateTime.now() >= DateTime.fromISO(data.consignment_end)) {
        data.consignment_closed = true
      }

      data.consignment_end_iso = data.consignment_end

      data.sale_start = DateTime.fromISO(data.sale_start).toLocaleString(DateTime.DATETIME_MED)
      data.sale_end = DateTime.fromISO(data.sale_end).toLocaleString(DateTime.DATETIME_MED)
      data.consignment_start = DateTime.fromISO(data.consignment_start).toLocaleString(DateTime.DATETIME_MED)
      data.consignment_end = DateTime.fromISO(data.consignment_end).toLocaleString(DateTime.DATETIME_MED)

      super(data)
    }

    get open() {
      return this.status === 'open';
    }

    ordersByHour(orders) {
      const dates = orders
        .map(o => DateTime.fromISO(o.createdAt))
        .sort((a, b) => a.toMillis() - b.toMillis());

      return dates.map(d => d.toFormat('yyyy-LL-dd HH:00:00')).toSet();
    }
  }
